export default __webpack_public_path__ + "static/media/create_inspection_job_white.122c3722.svg";